module.exports = "https://r.nearpod.com/assets/media/image/scissors-af3bee53cfb4b0089c5d7b7c1871c463.svg";